import { RunTotalAudit, RunTotalAuditChartsResponse } from '../../store/RunTotalAudit';
import { ApiAdvancedFilter, PaginatedResponse } from '../../store/GeneralStore';
import { buildAdvancedQueryURL } from '../../utils/helpers';
import { apiService } from '../APIService';

const API_SERVER_URL = process.env.REACT_APP_API_SERVER_URL;

export const listRunTotalAudits = (filters?: ApiAdvancedFilter) => {
  const mergedFilters: ApiAdvancedFilter = {
    page: 1,
    pageSize: 100,
    ...filters,
    orders: filters?.orders ?? [{ sort: 'number', direction: 'desc' }]
  };

  return apiService.callExternalApi<PaginatedResponse<RunTotalAudit>>({
    url: buildAdvancedQueryURL(mergedFilters, 'audits/run-totals'),
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const createRunTotalAuditData = (startBeforeSnapshot: boolean) => {
  return apiService.callExternalApi<RunTotalAudit>({
    url: `${API_SERVER_URL}/audits/run-totals?startBeforeSnapshot=${startBeforeSnapshot}`,
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const getRunTotalAudit = (id: string) => {
  return apiService.callExternalApi<RunTotalAudit>({
    url: `${API_SERVER_URL}/audits/run-totals/${id}`,
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const putRunTotalAudit = (runTotalAuditId: string, stage: string) => {
  return apiService.callExternalApi<RunTotalAudit>({
    url: `${API_SERVER_URL}/audits/run-totals/${runTotalAuditId}?stage=${stage}`,
    method: 'PUT',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const getRunTotalAuditCharts = () => {
  return apiService.callExternalApi<RunTotalAuditChartsResponse>({
    url: `${API_SERVER_URL}/audits/run-totals/charts`,
    method: 'GET',
    headers: { 'content-type': 'application/json' }
  });
};
